import { insertRecipe } from './operations';

const slashMenu = {
  Recipe: { icon: 'recipes', transform: insertRecipe },
};

export default slashMenu;
